<template>
  <div
    class="mb-2 h-64 w-full overflow-hidden sm:h-96 md:h-64"
  >
    <div
      v-if="showInsufficientDataMessage"
      class="flex h-full items-center justify-center px-6 text-center text-sm text-background-fg/70"
    >
      Insufficient data to produce transaction report
    </div>
    <ChartLineDate
      v-else-if="
        merchantGroup &&
        datasets[0] &&
        datasets[0].data.length > 0
      "
      id="transactions-cumulative-graph"
      :labels="labels"
      :datasets="datasets"
      :granularity="granularity"
      is-cumulative
      :currency="merchantGroup.currency"
    />
    <div v-else-if="isError" class="flex items-center">
      <IconExclamationCircleFilled
        class="mr-2 text-error"
      />
      <span> Failed to load transaction report </span>
    </div>

    <BaseInnerLoading v-else />
  </div>
</template>

<script setup lang="ts">
const merchantGroup = useMerchantGroup()
const { data, isError } =
  useMerchantGroupTransactionReport()

const granularity = computed(() => data.value?.granularity)
const showInsufficientDataMessage = computed(
  () => granularity.value === "hour"
)

const labels = computed(
  () =>
    data.value?.dataset?.map(({ start, end }) => ({
      start,
      end,
    })) || []
)

const datasets = computed(() => {
  const colorVariableName = "--color-primary"
  const colorVariable = colorVariableName
    ? useCssVar(colorVariableName).value
    : undefined
  const color = colorVariable
    ? `rgb(${colorVariable})`
    : undefined
  return [
    {
      label: "",
      data:
        data.value?.dataset?.map(({ value }) => value) ||
        [],
      color: color,
    },
  ]
})
</script>
